module.exports = __webpack_public_path__ + "static/img/BG@2x.88027fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/BG@2x.png
// module id = XigM
// module chunks = 44